import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { handleAPIError } from '@/utils/handle-api-error';
import { getLicenseOverviewAction } from '@/redux/actions/company';
import { getLicenseOverview, TLicenseOverviewResponse } from '@/services/api/company';

export function* getLicenseOverviewSaga(action: ActionType<typeof getLicenseOverviewAction.request>): Generator {
  const { materials, successCallback, failedCallback } = action.payload;
  try {
    const response = yield call(getLicenseOverview, materials);
    const overview: TLicenseOverviewResponse = response as TLicenseOverviewResponse;
    yield put(getLicenseOverviewAction.success(overview));
    successCallback?.(overview);
  } catch (err) {
    handleAPIError(err, 'Error.getLicenseOverviewError');
    yield put(getLicenseOverviewAction.failure(err));
    failedCallback?.(err);
  }
}
